<template>
  <a
    class="shape-link"
    href="/participants-page"
    @click.prevent="changeRoute('/participants-page')"
  >
    <div class="about-category__inner">
      <BaseCaption v-if="item.caption" :text="item.caption" />
      <BaseText v-if="item.descr" :text="item.descr" />
      <ShapeNumberItem :index="index" src="link-number" />
    </div>
  </a>
</template>

<script>
import ShapeNumberItem from '~/components/ShapeNumberItem'

export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    disabled() {
      return !this.item.imgId
    }
  },
  methods: {
    changeRoute(route) {
      this.$router.push({
        path: route,
        query: { categoryId: `category${this.item.imgId}` }
      })
    }
  },
  components: {
    ShapeNumberItem
  }
}
</script>

<style>
.shape-link {
  display: block;
  width: 100%;
  height: 100%;
}

.disabled {
  opacity: 0.2;
  pointer-events: none;
  cursor: disabled;
}
</style>



// WEBPACK FOOTER //
// components/ShapeListLink.vue